// extracted by mini-css-extract-plugin
export default {"table_custom":"Detail_table_custom__mAyVc"};